import React from "react";
import { createRoot } from "react-dom/client";
import Root from "./components/root";

// Mounted via `new reactAppList.IndicatorTableApp(...)` (application_helper#render_react_app).
// Must be a function/class, NOT an arrow — arrows are not constructable. Under Babel this was an
// arrow down-levelled to an ES5 function; esbuild keeps arrows as-is (es2017), so `new` would throw.
export default function IndicatorTableApp(htmlNode, props) {
  createRoot(htmlNode).render(<Root {...props} />);
}
